import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "auto",
  fill: "none",
  viewBox: "0 0 42 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M10 17h22\"></path><circle cx=\"26\" cy=\"17\" r=\"3\" fill=\"currentColor\"></circle><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M32 26H10\"></path><circle cx=\"16\" cy=\"26\" r=\"3\" fill=\"currentColor\" transform=\"rotate(-180 16 26)\"></circle><circle cx=\"21\" cy=\"21\" r=\"20.5\" stroke=\"currentColor\"></circle>", 5)
  ])))
}
export default { render: render }